let storage

// In dev mode, use sessionStorage, in production use localStorage
if (process.env.NODE_ENV === 'development' || window.location.href.includes('localhost')) {
  storage = window.sessionStorage
}
else {
  storage = window.localStorage
}

export default {
  get(key) {
    return storage.getItem(key)
  },
  set(key, value) {
    storage.setItem(key, value)
  },
  remove(key) {
    storage.removeItem(key)
  }
}
